/**
 * @param {object} objectData object to send
 * @returns {FormData} FormData object
 */
export const objectToFormData = (objectToForm) => {
    let formData = new FormData();
    Object.keys(objectToForm).forEach(key => {
        if (typeof objectToForm[key] === 'object') {
            for (let previewKey in objectToForm[key]) {
                if (typeof objectToForm[previewKey] === 'object') {
                    if (containValue(objectToForm[key][previewKey]))
                        formData.append(`${key}[${previewKey}]`, JSON.stringify(objectToForm[key][previewKey]));
                } else {
                    if (containValue(objectToForm[key][previewKey]))
                        formData.append(`${key}[${previewKey}]`, objectToForm[key][previewKey]);
                }
            }
        } else {
            if (containValue(objectToForm[key]))
                formData.append(key, objectToForm[key])
        }
    });
    return formData;
};
const containValue = (value) => !(value === null || value === undefined);
